import { paths } from '@/app/router/paths';

/**
 * Het statusfilter van Keuringen staat in het adres (`/keuringen?status=nieuw`),
 * zodat een getal elders in de app - "3 keuringen wachten op een afspraak" op de
 * Planning - rechtstreeks naar precies die keuringen kan wijzen.
 */
export const STATUS_PARAM = 'status';

/** `?nieuw=1` opent meteen het formulier, bijvoorbeeld vanaf het dashboard of de Planning. */
export const NEW_PARAM = 'nieuw';

/** Keuringen, gefilterd op één filtersleutel uit `ORDER_FILTERS` of `ORDER_LINK_FILTERS`. */
export function inspectionsWithStatus(key: string): string {
    return `${paths.inspections}?${STATUS_PARAM}=${encodeURIComponent(key)}`;
}

/** Keuringen met het formulier Nieuwe keuring open. */
export const NEW_INSPECTION_PATH = `${paths.inspections}?${NEW_PARAM}=1`;
